import { render, staticRenderFns } from "./BottomPlayer.vue?vue&type=template&id=6df42960&"
import script from "./BottomPlayer.vue?vue&type=script&lang=ts&"
export * from "./BottomPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./BottomPlayer.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports